export default __webpack_public_path__ + "static/media/Shopee.73bb4bcb.svg";